export default {
    props: {
        modelValue: {
            type: String,
            default: ""
        }
    },
    data () {
        return {
            route: "",
            routeList: [
                {
                    label: "基础链接",
                    children: [
                        {
                            label: '领券中心',
                            value: "/packageMarket/coupon/index"
                        },
                        {
                            label: '关于我们',
                            value: "/pages/agreement/aboutus"
                        },
                        {
                            label: '关于财神',
                            value: "/pages/agreement/aboutmammon"
                        }
                    ]
                },
                {
                    label: "分销",
                    children: [
                        {
                            label: "服务中心",
                            value: "/packageService/identity/index"
                        },
                        {
                            label: "分销中心",
                            value: '/packageAgent/center/index'
                        },
                        {
                            label: "合作咨询",
                            value: '/packageService/cooperation/index'
                        }
                    ]
                }
            ]
        };
    },
    mounted () {},
    watch: {
        modelValue: {
            handler (newVal) {
                this.route = newVal;
            },
            immediate: true,
            deep: true
        },
        route (val) {
            this.$emit('update:modelValue', val);
        }
    },
    methods: {
        onChange (val) {
            this.route = val;
        }
    }
};
